
import Button from '@/components/Button.vue'
import ChoiceButton from '@/components/ChoiceButton.vue'
import { useDeposit } from '@/modules/in/in'
import { DepositChannel, readChannelList, readDepositChoices } from '@/modules/in/in.api'
import In from '@/modules/in/In.vue'
import TheChannels from '@/modules/out/components/TheChannels.vue'
import HoldOn from '@/provider/HoldOn.vue'
import ExchangeRate from '@/views/ExchangeRate.vue'
import Matrix from 'common/Matrix.vue'
import { defineComponent, shallowRef, nextTick, onMounted } from 'vue'
import Line from '@/components/Line.vue'
import BonusList from '@/modules/in/components/BonusList.vue'
import Pic from '@/components/Pic.vue'
import { format } from '@/config'

export default defineComponent({
  name: 'ChannelForCommon',
  components: {
    In,
    TheChannels,
    ChoiceButton,
    BonusList,
    Line,
    ExchangeRate,
    HoldOn,
    Button,
    Matrix,
    Pic,
  },
  props: {
    customRequest: Function,
  },
  setup (props) {
    const amount = shallowRef('0')
    const [commit, progress] = useDeposit()
    const channels = shallowRef<DepositChannel[]>()
    const channel = shallowRef<string>('')
    const options = shallowRef<Array<string>>([])
    const selectIndex = shallowRef(0)
    const disabled = shallowRef(false)

    onMounted(() => {
      Promise.all([readDepositChoices(), readChannelList()]).then((res) => {
        nextTick(() => {
          options.value = res[0].list
          channels.value = res[1]
          channel.value = res[1][0]?.code ?? ''
          for (let i = 0; i < options.value?.length; i++) {
            if (+options.value[i] >= +(channels.value?.[selectIndex.value].minAmount || 0)) {
              amount.value = options.value[i]
              break
            }
          }
          disableInit()
        })
      })
    })

    const disableInit = () => {
      const camount = amount.value === '0' ? +(options.value ?? ['0'])[0] : +amount.value
      const cmax = channels.value?.[selectIndex.value].maxAmount || +options.value[options.value.length - 1]
      const cmin = channels.value?.[selectIndex.value].minAmount || 0
      if (camount > cmax || camount < cmin) {
        disabled.value = true
      } else {
        disabled.value = false
      }
    }

    const changeDepositAmount = (item: string) => {
      amount.value = item
      disableInit()
    }

    const select = (data: string) => {
      console.log(data, '===')
    }

    const request = (amount: string) => {
      if (disabled.value) {
        return
      }
      const params: Record<string, unknown> = {
        amount,
      }

      if (channel.value) {
        params.payChannel = channel.value
      }

      const result = props.customRequest?.(params)

      if (result !== false) {
        return commit(params)
      }
    }

    const channelChange = (index: number) => {
      channel.value = channels.value ? channels.value[index].code : ''
      selectIndex.value = index
      disableInit()
    }

    return {
      channels,
      channel,
      options,
      amount,
      selectIndex,
      disabled,
      commit: request,
      progress,
      changeDepositAmount,
      select,
      channelChange,
      showBonus: false,
      format,
    }
  },
})
